
import { mapState, mapGetters, mapMutations } from "vuex";
import MenuUploadDraggableItem from "./menu-upload-draggable-item.vue";

export default {
  components: { MenuUploadDraggableItem },
  props: {
    propName: {
      type: String,
      default: ""
    }
  }
};
